// extracted by mini-css-extract-plugin
module.exports = {"moreOnGamesTitle":"dovQg","sliderWrap":"rihyY","dottedLine":"ks2El","toiGameCapsule":"pbH_f","iconToiGames":"l9QYl","mobileScroll":"VNdQn","topTitle":"NbPMU","exploreLink":"B943z"};